import { EMPTY, Observable } from 'rxjs';
import { catchError, shareReplay, tap } from 'rxjs/operators';

import { SnackBarService } from './snackbar.service';

/**
 * Trimite cererea imediat (apelurile vechi, care nu se aboneaza, merg la fel), aplica efectele
 * de succes din serviciu si arata eroarea. Intoarce rezultatul pentru componenta: emite o data
 * la succes si se incheie fara valoare la eroare (eroarea e deja afisata), deci componenta poate
 * inchide un formular sau un dialog doar dupa ce operatia a reusit.
 */
export function executa<T>(cerere: Observable<T>, succes: (raspuns: T) => void, snackBar: SnackBarService): Observable<T> {
    const rezultat = cerere.pipe(
        tap(succes),
        catchError(error => {
            snackBar.showError(error);
            return EMPTY;
        }),
        shareReplay({ bufferSize: 1, refCount: false }),
    );
    rezultat.subscribe();
    return rezultat;
}
